// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createCate_title__4SA4C {
  font-weight: 700;
  font-size: 3rem;
}

.createCate_category__BvHum {
  font-size: 1.6rem;
}
.createCate_category__BvHum:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.createCate_tit__kB2jf {
  font-size: 1.8rem;
  font-weight: 600;
}

.createCate_categories__WYwuI {
  font-size: 1.4rem;
}
.createCate_categories__WYwuI:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important;
  border-color: #6c757d;
}

.createCate_danger__Q4o6k {
  font-size: 1.4rem;
}

.createCate_new-post__xdS48 {
  font-size: 1.6rem;
  border-radius: 8px;
}
.createCate_new-post__xdS48:hover {
  color: #6c757d;
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/Admin/category/createCategory/createCate.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;AACI;EACI,aAAA;EACA,4DAAA;EACA,qBAAA;AACR;;AAEA;EACI,iBAAA;EACA,gBAAA;AACJ;;AACA;EACI,iBAAA;AAEJ;AAAI;EACI,aAAA;EACA,4DAAA;EACA,qBAAA;AAER;;AACA;EACI,iBAAA;AAEJ;;AAAA;EACI,iBAAA;EACA,kBAAA;AAGJ;AADI;EACI,cAAA;EACA,6BAAA;AAGR","sourcesContent":[".title{\n    font-weight: 700;\n    font-size: 3rem;\n    // padding: 50px 0;\n}\n.category{\n    font-size: 1.6rem;\n\n    &:focus{\n        outline: none;\n        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n        border-color: #6c757d;\n  }\n}\n.tit{\n    font-size: 1.8rem;\n    font-weight: 600;\n}\n.categories{\n    font-size: 1.4rem;\n\n    &:focus{\n        outline: none;\n        box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.3) !important; \n        border-color: #6c757d;\n  }\n}\n.danger{\n    font-size: 1.4rem;\n}\n.new-post{\n    font-size: 1.6rem;\n    border-radius: 8px;\n\n    &:hover{\n        color: #6c757d;\n        background-color: transparent;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `createCate_title__4SA4C`,
	"category": `createCate_category__BvHum`,
	"tit": `createCate_tit__kB2jf`,
	"categories": `createCate_categories__WYwuI`,
	"danger": `createCate_danger__Q4o6k`,
	"new-post": `createCate_new-post__xdS48`
};
export default ___CSS_LOADER_EXPORT___;
